import { useCMSPageField } from '@/cms/fields'
import { mqMin, space } from '@sunwebgroup/ui-components'
import { Rating, Typography } from '@sunwebgroup/ui-components/uds'
import { styled } from 'styled-components'
import { Breadcrumb } from './Breadcrumb'

const Wrapper = styled.div`
  padding: 0 0 ${space('primitives_space_16')} 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${space('primitives_space_4')};

  @media ${mqMin('primitives_breakpoint_m_min')} {
    padding: ${space('primitives_space_16')} 0;
    align-items: center;
    text-align: center;
    gap: ${space('primitives_space_8')};
  }
  @media ${mqMin('primitives_breakpoint_l_min')} {
    padding: ${space('primitives_space_24')} 0;
  }
`
const Title = styled(Typography)`
  // Override UDS Typography styles due to styled-components specificity issues
  ${Typography.modVariant('display-f-regular')} !important;

  @media ${mqMin('primitives_breakpoint_m_min')} {
    // Override UDS Typography styles due to styled-components specificity issues
    ${Typography.modVariant('display-e-regular')} !important;
  }

  @media ${mqMin('primitives_breakpoint_l_min')} {
    // Override UDS Typography styles due to styled-components specificity issues
    ${Typography.modVariant('display-c-regular')} !important;
  }
`

const Subtitle = styled.div`
  display: flex;
  align-items: center;
  gap: 0 ${space('primitives_space_12')};
  flex-wrap: wrap;

  @media ${mqMin('primitives_breakpoint_l_min')} {
    gap: 0 ${space('primitives_space_16')};
  }
`

export function Header() {
  const titleLabel = useCMSPageField('PDP.title')
  const rating = useCMSPageField('PDP.rating')
  return (
    <Wrapper>
      <Title>{titleLabel}</Title>
      <Subtitle>
        <Rating rating={rating} />
        <Breadcrumb />
      </Subtitle>
    </Wrapper>
  )
}
